// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"217b8efa","186":"ad1d1ea4","344":"5be93827","372":"2054b3e9","738":"99453fcc","787":"9e9f4ffd","841":"d9bb2e40","856":"2c11002b"}[chunkId] + ".chunk.js";
};